import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import { getOrCreateFilmstrip } from "./actions";

export const filmstripEntityAdapter = createEntityAdapter({
  selectId: (entity) => `${entity.contentId}-${entity.startTime}-${entity.endTime}`,
});

const initialState = filmstripEntityAdapter.getInitialState({});

export const filmstripSlice = createSlice({
  name: "filmstrip",
  initialState: initialState,
  reducers: {
    upsertFilmstrip: (state, action) => {
      filmstripEntityAdapter.upsertOne(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getOrCreateFilmstrip.fulfilled, (state, action) => {
      if (action.payload && action.payload.data?.filmstrip) {
        filmstripEntityAdapter.upsertOne(state, action.payload.data?.filmstrip);
      }
    });
  },
});

export const { upsertFilmstrip } = filmstripSlice.actions;

export default filmstripSlice.reducer;
